<template>
  <div class="">
    <tabs
      v-model="active"
      color="#4FD9D5"
      title-active-color="#4FD9D5"
      title-inactive-color="#999999"
      line-width="33.33%"
      :border="true"
      sticky
    >
      <tab v-for="(item, index) in tabs" :key="index" :title="item.title">
        <list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="item" v-for="(item, index) in list" :key="index">
            <div class="item-title">
              <div class="order-num">订单号：{{ item.order_sn }}</div>

              <div class="state" v-if="item.status == 0">待支付</div>
              <div class="state" v-if="item.status == 1">进行中</div>
              <div class="state" v-if="item.status == 2">待评价</div>
              <div class="state" v-if="item.status == 3">已评价</div>
              <div class="state" v-if="item.status == -1">已取消</div>
              <div class="state" style="color: #f48e97" v-if="item.status == 4">
                申请退款
              </div>
              <div class="state" v-if="item.status == 5">已退款</div>
              <div class="state" v-if="item.status == 6">退款失败</div>
            </div>

            <div class="user">
              <div class="user-img">
                <van-image
                  width="1rem"
                  height="1rem"
                  fit="cover"
                  :src="item.goods_thumb"
                />
              </div>
              <div>
                <div class="question">{{ item.title }}</div>
                <div class="price">
                  ￥<span>{{ item.pay_type != 'system' ? item.price : item.money }}</span>
                </div>
              </div>
            </div>

            <div class="item-btn">
              <div v-if="item.status == 0" @click="cancelOrder(item, index)">
                取消订单
              </div>
              <div v-if="item.status == 0" @click="payment(item)">立即支付</div>
              <div v-if="item.status == 1" @click="jump_chat(item)">
                进入咨询
              </div>
              <div v-if="item.status == 1" @click="orderConfirm(item)">
                确认完成
              </div>
              <div v-if="item.status == 2" @click="evaluate(item)">评价</div>
            </div>
          </div>
        </list>
      </tab>
    </tabs>
  </div>
</template>

<script>
/**
@description:咨询订单
@createTime:2021-09-01
@create:wq
*/
import { Tab, Tabs, List, Dialog } from "vant";
import { getQueryString } from "@/utils/tool";
import wx from "jweixin-module";
export default {
  name: "",
  props: {},
  components: { Tab, Tabs, List, [Dialog.Component.name]: Dialog.Component },
  data() {
    return {
      active: 0,
      tabs: [
        { title: "全部", status: 0 },
        { title: "进行中", status: 2 },
        { title: "已完成", status: 3 },
      ],
      page: 1,
      loading: false,
      finished: false,
      list: [],
      href: "http://h5.keyice.club/alipay/",
    };
  },
  computed: {},
  watch: {
    active() {
      this.loading = false;
      this.finished = false;
      this.list = [];
      this.page = 1;
      // this.onLoad();
    },
  },
  mounted() {},
  created() {
    this.jsSdk();
    let code = getQueryString("code");
    console.log(code, "----------------------code-------------------");
    if (!code) {
      if (this.$route.query && this.$route.query.s) {
        this.type = this.$route.query.s;
      }
    } else {
      let state = getQueryString('state');
      state = state.substring(0, state.indexOf("#/"));
      // console.log(state,'-------------------------------');
      let orderId = state.split("orid");
      this.type = orderId[0];
      this.orderId = orderId[1];
      if (code) {
        this.getopenid(code);
      }
    }
  },
  methods: {
    getopenid(code) {
      this.api.getOpenid({ opcode: code }).then((res) => {
        this.api.pay({ id: this.orderId, openid: res.data }).then((res) => {
          this.payParams = res;
          console.log(res);
          if (res.data.systemPay == 1) {
            this.Toast.clear();
            this.Toast.success("支付成功");
            
            return;
          }
          this.Toast.clear();
          this.wxPayFn(res);
        });
      });
    },
    wxPayFn(res) {
      let that = this;
      // 微信支付
      wx.chooseWXPay({
        timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
        package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: res.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: res.data.paySign, // 支付签名
        success: function() {
          that.Toast.clear();
          that.getList();
          // 支付成功后的回调函数
        },
        fail: () => {
          this.Toast.clear();
          this.Toast("取消支付");
        },
      });
    },
    getList() {
      const status = this.tabs[this.active].status;
      this.api
        .myOrder({ type: 1, status: status, page: this.page })
        .then((res) => {
          console.log(res);
          if (this.page == 1) {
            this.list = [];
          }
          this.list = [...this.list, ...res.data.data];
          if (res.data.to < res.data.per_page) {
            this.loading = true;
            this.finished = true;
          } else {
            this.loading = false;
            // this.finished = false;
          }
        });
    },
    payment(item) {
      let id = item.id;
      const that = this;
      this.Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      if (item.pay_type == "ali") {
        let order_sn = item.order_sn;
        this.href = this.href + order_sn;
        this.Toast.clear();
        window.location.href = this.href;
        return;
      }
      //微信支付
      this.api.getAppid().then((res) => {
        console.log(res.data);
        let appid = res.data;
        const url =
          location.origin +
          location.pathname +
          "?appid=" +
          appid +
          "#/orderzx";
        const redirect_uri = encodeURIComponent(url);
        let f = `1orid${id}`;
        console.log(f);
        // return
        location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${f}#wechat_redirect`;
      });
      // this.api.pay({ id }).then((res) => {
      //   this.payParams = res;
      //   // console.log(res);
      //   // 微信支付
      //   wx.chooseWXPay({
      //     timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
      //     nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
      //     package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
      //     signType: res.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
      //     paySign: res.data.paySign, // 支付签名
      //     success: function() {
      //       setTimeout(() => {
      //         that.Toast.clear();
      //         if (that.type == 1) {
      //           that.$router.replace("orderzx");
      //         } else if (that.type == 2) {
      //           that.$router.replace("orderaw");
      //         } else if (that.type == 3) {
      //           that.$router.replace("kcOrder");
      //         }
      //       }, 2000);
      //       // 支付成功后的回调函数
      //     },
      //   });
      // });
    },

    jsSdk() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let url = "";
      if (isiOS) {
        url = window.location.href.split("#")[0];
      } else {
        url = window.location.href;
      }
      this.api.jsSdk({ url }).then((res) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
        });
        wx.ready(function() {
          console.log("===========");
          wx.error((res) => {
            console.log(res);
          });
          // TODO
        });
      });
    },
    orderConfirm(item) {
      Dialog.confirm({
        message: "确认完成该课程？",
      })
        .then(() => {
          this.api.confirmOrder({ id: item.id }).then(() => {
            this.page = 1;
            this.getList();
            this.Toast.success("确认成功");
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    chat(item) {
      // `/pages/users/msg/chat?id=${item.id}&oid=${item.oid}&s=${item.status}&t=${item.oStatus}&remind=${item.remind}`
      this.$router.push({
        path: "chat",
        query: {
          id: item.id,
          oid: item.oid,
          s: item.status,
          t: item.oStatus,
          remind: item.remind,
        },
      });
    },
    evaluate(item) {
      this.$router.push({
        path: "evaluate",
        query: {
          id: item.id,
        },
      });
    },
    onLoad() {
      console.log(1);
      this.getList();
      this.page++;
    },

    cancelOrder(item) {
      this.api.cancelOrder({ id: item.id }).then(() => {
        item.status = -1;
        // this.list.splice(index, 1);
        this.Toast("取消成功");
      });
    },
    jump_chat(item) {
      if (item.status == 0 || item.status == -1) return;
      this.$router.push({
        path: "chat",
        query: {
          id: item.room_id,
          oid: item.id,
          t: item.roomStatus,
          s: item.roomStatus,
          remind: item.remind,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  //   height: 2.56rem;
  background: #ffffff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.16);
  border-radius: 5px;
  margin: 0.24rem;
  padding: 0 0.2rem;
  .item-title {
    border-bottom: 1px solid #f0f0f0;
    height: 0.8rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    font-size: 0.24rem;
    font-weight: 400;
    color: #999999;
  }
  .user {
    display: flex;
    align-items: center;
    padding: 0.36rem 0;
    .user-img {
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 0.22rem;
      flex-shrink: 0;
    }
    .question {
      font-size: 0.3rem;
      font-weight: 400;
      color: #666666;
    }
    .price {
      font-size: 0.24rem;
      font-weight: bold;
      color: #f9647d;
      span {
        font-size: 0.36rem;
      }
    }
  }
  .item-btn {
    font-size: 0.28rem;
    font-weight: 500;
    color: #4fd9d5;
    display: flex;
    justify-content: flex-end;
    padding-bottom: 0.16rem;
    > div {
      width: 1.68rem;
      height: 0.6rem;
      border-radius: 0.4rem;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba($color: #4fd9d5, $alpha: 0.1);
      border: 1px solid #4fd9d5;
      margin-right: 0.08rem;
      &:last-child {
        border: none;
        background: #4fd9d5;
        color: #ffffff;
        margin-right: 0;
      }
    }
  }
}
</style>
